'use client'

import classNames from 'classnames'

import { getPublicEnv } from '@/shared/env'
import { openLoginModal } from '@/shared/lib/login-modal'
import { type Language, useI18n } from '@/shared/providers'
import { useLoggedIn } from '@/shared/providers/public-id'

import styles from './view.module.css'

type PostTranslateButtonProps = {
    isTranslated: boolean
    onClick: (lang: Language) => void
}

export function PostTranslateButton({ isTranslated, onClick }: PostTranslateButtonProps) {
    const runtimeEnv = getPublicEnv()
    const loggedIn = useLoggedIn()

    const { lang: portalLang, i18n } = useI18n()
    const sourceLang = runtimeEnv.NEXT_PUBLIC_LANG

    const handleClick = () => {
        if (!loggedIn) {
            openLoginModal('translation')
            return
        }

        onClick(isTranslated ? sourceLang : portalLang)
    }

    if (!runtimeEnv.NEXT_PUBLIC_AUTO_TRANSLATION_ENABLE) {
        return null
    }

    if (portalLang === sourceLang) {
        return null
    }

    return (
        <button
            className={classNames('btn btn-sm', styles.translateButton, { [styles.translated!]: isTranslated })}
            onClick={handleClick}
        >
            <i
                className={classNames('fa-globe', {
                    'fa-solid': isTranslated,
                    'fa-regular': !isTranslated,
                })}
            />
            {isTranslated ? (
                <span className="pl-1">{i18n.PORTAL_NEWS_BTN_SHOW_ORIGINAL}</span>
            ) : (
                <span className="pl-1">{i18n.PORTAL_NEWS_BTN_MACHINE_TRANSLATION}</span>
            )}
        </button>
    )
}
